import { h, Component } from 'preact'
import Header from '../header'
import ButtonControl from '../button-control'
import Icon from '../assets'
import AccordionPanel from '../panel/AccordionPanel'
import { PanelHeaderWithIcon } from '../registration-rules/PanelItems'
import SimplePanel from '../ui-components/SimplePanel'

type Props = {
}

type State = {
}

const dataExportPanel = {
  heading: 'Analytics',
  title: <PanelHeaderWithIcon title='Data export' icon='downloadCloud' customClass='panel-header-container' />,
  body: <a href='/ideas/export' target='_blank' class='ideation-ideas-export'><ButtonControl
    newStyle
    size='medium'
    title='Export all ideas in CSV'
    variant='brand'
  /></a>
}

export class Ideation extends Component<Props, State> {
  render () {
    return (
      <div className='ideation-platform-page'>
        <Header
          title='Ideation'
          disableSaveButton
          disableCancelButton
          customButtons={[
            <a href='/idea/overview' target='_blank'>
              <ButtonControl
                title={<div class='ideation-overview-link'>Go to ideation overview page<Icon icon={'openInNew'} width={16} height={16} /></div>}
                variant='secondary'
                newStyle
                size='medium'
              />
            </a>
          ]}
        />
        <AccordionPanel
          panels={[dataExportPanel]}
        />
        <h2 className='panel-new__heading ideation-platform-settings'>Setting</h2>
        <SimplePanel className='ideation-platform-permissions-panel' image={<Icon icon='key' width={30} height={30} color='#0069FF'/>}>
          <a className='ideation-platform-permissions-link' href='/platform/ideation/permissions' />
          <div class='ideation-permissions__title'><h5>Permissions</h5></div>
          <div class='ideation-permissions__description'>Manage visibility, creation, reply and upvote permissions</div>
        </SimplePanel>
      </div>
    )
  }
}

export default Ideation
